import { Box, IconButton } from "@mui/material";
import MenuRounded from "@mui/icons-material/MenuRounded";
import { PropsWithChildren } from "react";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import { purpleLight } from "../../../theme/colors";
import NavSearch from "./nav_search";
import Profile from "./profile";

export default function Navbar({
  onMenuClick,
}: PropsWithChildren<{ onMenuClick?: () => void }>) {
  return (
    <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" gap={{ xs: 1, sm: 2 }}>
      <Box display="flex" alignItems="center" gap={1} minWidth={0}>
        {onMenuClick && (
          <IconButton
            onClick={onMenuClick}
            sx={{ display: { xs: "inline-flex", sm: "none" }, "&:hover": { bgcolor: purpleLight } }}
          >
            <MenuRounded />
          </IconButton>
        )}
        <Box sx={{ display: { xs: "none", sm: "block" } }}>
          <Breadcrumb />
        </Box>
      </Box>

      <Box display="flex" flexDirection="row" alignItems="center" gap={{ xs: 1, sm: 2 }}>
        <NavSearch />
        <Profile />
      </Box>
    </Box>
  );
}
